export enum MUTATION_TYPES {
  SET_LOGIN_DATA = "SET_LOGIN_DATA",
  SET_SOCIAL_LOGIN = "SET_SOCIAL_LOGIN",
  SET_USER = "SET_USER",
  SET_VERIFICATION_STATUS = "SET_VERIFICATION_STATUS",
  SET_USER_VERIFICATION = "SET_USER_VERIFICATION",
  SET_CREDIT_CARDS = "SET_CREDIT_CARDS",
  SET_REDIRECT_PATH = "SET_REDIRECT_PATH",
  SET_DO_NOT_DISTURB = "SET_DO_NOT_DISTURB",
  SET_USER_BALANCE = "SET_USER_BALANCE",
  SET_STATE = "SET_STATE",
  SET_DARK_MODE = "SET_DARK_MODE",
  SET_MY_SUBSCRIPTION_LEVELS = "SET_MY_SUBSCRIPTION_LEVELS",
  SET_PAYMENT_PACKAGES = "SET_PAYMENT_PACKAGES",
  SET_TAGS = "SET_TAGS",
  SET_GLOBAL_PLAYER = "SET_GLOBAL_PLAYER",
  SET_ONBOARDING = "SET_ONBOARDING",
  LOGOUT = "LOGOUT",
}

export enum ACTION_TYPES {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  GET_SYSTEM_SETTINGS = "GET_SYSTEM_SETTINGS",
  GET_VERIFICATION_STATUS = "GET_VERIFICATION_STATUS",
  GET_ONBOARDING = "GET_ONBOARDING",
  GET_USER_PUBLIC_INFORMATION = "GET_USER_PUBLIC_INFORMATION",
}
